import { useState } from "react";
import { X } from "lucide-react";
import { useLoginSlideOverStore } from "@/store/loginSlideOverStore";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api-client";
import { useAuthStore } from "@/store/authStore";
import { Link } from "react-router-dom";

export function LoginSlideOver() {
  const { isOpen, close } = useLoginSlideOverStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      close();
    } catch (err: any) {
      setError(err.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* Dark overlay */}
      <div
        className={`fixed inset-0 z-50 bg-black/60 transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={close}
      />

      {/* Slide-over panel */}
      <div
        className={`fixed right-0 top-0 z-50 h-full w-96 max-w-full bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full p-6">
          <div className="flex items-center justify-between mb-8">
            <h2 className="font-display text-xl font-semibold text-steel">
              Member Access
            </h2>
            <button
              onClick={close}
              className="flex h-8 w-8 items-center justify-center rounded-full text-steel-600 hover:bg-concrete-100"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col flex-1 gap-4">
            <div>
              <Label htmlFor="login-email">Email</Label>
              <Input
                id="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />
            </div>
            <div>
              <Label htmlFor="login-password">Password</Label>
              <Input
                id="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            {error && <p className="text-xs text-rust">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full mt-2">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>

          <div className="mt-4 text-center text-xs text-steel-600">
            Not a member yet?{" "}
            <Link
              to="/account/register"
              onClick={close}
              className="font-medium text-amber hover:underline"
            >
              Create account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}